import { defineComponent as _defineComponent } from 'vue'
import {computed, ref, watch} from "vue";
import LoadingSpinner from "../../components/loaders/LoadingSpinner.vue";
import { IntersectionPaginationOption, IntersectionStateChanger } from "@/utils/types";


type Item = {
  title: string
  subtitle: string
  [key: string]: unknown
}


  export type AutoCompleteValue = { text: string, value: string | number } | string;

export default /*#__PURE__*/_defineComponent({
  __name: 'ChipsAutocomplete',
  props: {
    value: null,
    items: null,
    noDataText: null,
    paginated: { type: Boolean, default: false },
    loading: { type: Boolean },
    selectAllText: null,
    placeholder: null,
    maxWidth: { default: 0 },
    idKey: { default: 'subtitle' },
    hideDetails: { type: Boolean, default: false },
    rules: { default: () => [] }
  },
  emits: ["input", "search", "infinite"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", value: Item[]): void;
  (e: "search", value: { searchText: string | undefined | null, state: IntersectionStateChanger }): void;
  (e: "infinite", value: IntersectionStateChanger): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: Item[], items: Item[], noDataText: string, paginated: boolean, loading?: boolean, selectAllText: string, placeholder: string, maxWidth: number, idKey: string, hideDetails: boolean, rules: Array<string | boolean | ((value: object) => boolean | string)> };

const paginationRef = ref<IntersectionPaginationOption>({
  loaded: false,
  completed: false,
  searchText: undefined, 
  bounceTimer: undefined
})
const hasError = computed(()=> paginationRef.value?.hasError && paginationRef.value?.shouldValidate);





const selectedItems = computed({
  get: () => {
    return props.value;
  },
  set: (value) => {
    emit('input', value)
  }
})

function handleIntersection(entries: IntersectionObserverEntry[], observer: IntersectionObserver, isIntersecting: boolean) {
  if(isIntersecting) {
    if(paginationRef.value.completed) return;
    paginationRef.value.loaded = false;
    emit('infinite', state);
  }
}

watch(
  () => paginationRef.value.searchText,
  (newValue, oldValue) => {
    if(!props.paginated) return;
    if(newValue === oldValue) return;
    state.reset();
    
    if(paginationRef.value.searchText?.length && paginationRef.value.searchText === props.value.text) {
      return;
    }
    // debounce for the search
    clearTimeout(paginationRef.value.bounceTimer);
    paginationRef.value.bounceTimer = setTimeout(() => {
      emit('search', {searchText: paginationRef.value.searchText, state});
    }, 500);
  }
)

const state: IntersectionStateChanger = {
  loaded: () => {
    paginationRef.value.loaded = true;
  },
  completed: () => {
    paginationRef.value.completed = true;
  },
  reset: () => {
    paginationRef.value.loaded = false;
    paginationRef.value.completed = false;
  }
};

const remove = (removeItem: Item) => {
  const index = props.value.findIndex((item) => item[props.idKey] === removeItem[props.idKey]);
  const valueCopy = structuredClone(props.value);
  if (index >= 0) {
    valueCopy.splice(index, 1);
  }
  selectedItems.value = valueCopy;
};

const selectAll = () => {
  emit('input', props.value.length === props.items.length ? [] : props.items)
}

const filter = (item: Item, queryText: string) => {
  const matchesTitle = item.title.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
  const matchesSubtitle = item.subtitle.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
  return matchesTitle || matchesSubtitle;
}


return { __sfc: true,paginationRef, hasError, props, emit, selectedItems, handleIntersection, state, remove, selectAll, filter, LoadingSpinner }
}

})